/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import get from 'lodash/get';
import * as R from 'ramda';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import * as moment from 'moment';
import 'moment/locale/et';
import 'moment/locale/fi';
import 'moment/locale/ru';
import 'moment/locale/sv';
import { connect } from 'react-redux';
import { change, Field, formValueSelector, reduxForm, submit, untouch } from 'redux-form';
import { ArrowForward, CheckCircle, KeyboardArrowDown } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { withStyles } from '@mui/styles';
import { groupBy, isEqual } from 'lodash';
import { withTranslation } from 'react-i18next';
import { settings, siteId } from '../../sites';
import CustomIcon from '../../utils/CustomIcon';
import Alert from '../subcomponents/Alert';
import AvailableTime from '../subcomponents/AvailableTime';
import SelectedServiceBox from '../subcomponents/SelectedServiceBox';

import {
  clearAvailability,
  clearAvailableOpticians,
  clearFetchTimeStamp,
  clearMonthAvailability,
  getAvailability,
  getSpecialists,
  setAvailabilityStartDate,
} from '../../store/actions/availabilityActions';
import { clearUsedRedirection, saveUsedRedirection } from '../../store/actions/contentfulActions';
import {
  trackAvailableTimes,
  trackSaveUrlFragments,
  trackTimeFilterAfternoon,
  trackTimeFilterDay,
  trackTimeFilterEvening,
  trackTimeFilterMorning,
  trackUrlChange,
} from '../../store/actions/trackingActions';

import { returnField, validate } from '../../utils/FormHelpers';

import { siteIds } from '../../constants';
import { getDefaultGatCode, getDefaultLocaleLong, getLanguageGatCode } from '../../utils/localeUtils';
import { getPageTitle } from '../../utils/SEO';
import Breadcrumb from '../subcomponents/Breadcrumb';
import Calendar from '../subcomponents/Calendar';
import GoogleMap from '../subcomponents/GoogleMap';
import Info from '../subcomponents/Info';
import Title from '../subcomponents/Title';

const inlineStyles = theme => ({
  button: {
    width: '100%',
    textTransform: 'initial',
    fontSize: '14px',
    marginTop: 10,
    marginBottom: 10,
    [theme.breakpoints.up('md')]: {
      justifyContent: 'start',
      fontSize: '15px',
    },
  },
  expansionPanel: {
    width: '100%',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    '&:before': {
      opacity: '0',
    },
  },
  expansionPanelSummary: {
    padding: 0,
  },
  details: {
    padding: 0,
  },
  paddingLeftRight: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  availableTimes: {
    [theme.breakpoints.up('md')]: {
      marginTop: 30,
    },
  },
  timeSelectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  timeSelectionSpan: {
    marginTop: 5,
  },
  arrowForwardStyle: {
    fontSize: 12,
    verticalAlign: 'middle',
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
    },
  },
  form: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 16,
      paddingRight: 16,
      background: theme.box.background,
      borderRadius: theme.box.borderRadius,
      paddingTop: 30,
    },
  },
  field: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: 20,
    },
  },
  content: {
    marginBottom: 30,
    [theme.breakpoints.up('md')]: {
      marginBottom: 20,
    },
  },
  buttonGroupButton: {
    color: theme.palette.primary.secondary,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 700,
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
    },
  },
  buttonGroup: {
    marginBottom: 20,
    marginTop: 15,
  },
  h3: {
    textAlign: 'left',
  },
  serviceBox: {
    [theme.breakpoints.down('md')]: {
      order: -1,
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 40,
    },
  },
  chooseLocationAndTime: {
    [theme.breakpoints.down('md')]: {
      order: -2,
    },
  },
  body1: {
    textAlign: 'left',
    color: theme.palette.primary.main,
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(2, 0, 4),
  },
  circularProgress: {
    marginRight: '20px',
  },
  loading: {
    width: 'auto',
  },
  organisationName: {
    margin: '0',
    lineHeight: '18px',
  },
  organisationAddress: {
    fontSize: '13px',
    lineHeight: '20px',
  },
  helpBox: {
    backgroundColor: 'transparent',
    padding: '0',
    display: 'inline-flex',
    margin: '3px 0 0',
  },
  hideMapText: {
    display: 'none',
  },
  storeDetailsWrapper: {
    backgroundColor: '#F0F0F0',

    '& .MuiButton-endIcon': {
      transform: 'rotate(0deg)',
      transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    },
    '& .hideMapText': {
      display: 'none',
    },

    '&.Mui-expanded': {
      '& .hideMapText': {
        display: 'inline',
      },
      '& .showMapText': {
        display: 'none',
      },
      '& .MuiButton-endIcon': {
        transform: 'rotate(180deg)',
      },
    },
  },
  infoIcon: {
    fontSize: '16px',
    marginRight: '10px',
  },
  mapAccordionDetails: {
    padding: 0,
  },
  toggleMapButton: {
    '& .MuiButton-label': {
      alignItems: 'center !important',
    },
  },
  alert: {
    marginBottom: theme.spacing(4),
  },
});

const sortStoresAlphabetically = field => (a, b) => {
  const aName = a[field].replace(',', '');
  const bName = b[field].replace(',', '');
  if (aName < bName) {
    return -1;
  }
  if (aName > bName) {
    return 1;
  }
  return 0;
};
const capitalizeFirstLetter = str => {
  str = str.toLowerCase();
  return str.length ? str.charAt(0).toUpperCase() + str.slice(1) : str;
};
const timeout = null;

/**
 * SelectService
 * Filtering view to find an instance of a service (e.g. 13.30 @ Aleksanterinkatu Helsinki)
 * @param {Object} classes             Classes from JSS inlineStyles
 * @param {function} handleSubmit      Submit handling function
 * @param {function} getAvailability   Get Availability function
 * @param {function} clearAvailability Clear Availability function
 * @param {object} availableTimes      All available times
 * @param {object} history             History object for redirecting
 * @param {Object} t                   Translations
 */

class SelectService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeFilter: moment('07:00', 'HH:mm'),
      updateTimeStamp: Date(),
      stateTimeSlots: [],
      reservationDate: moment(),
    };
  }

  componentDidMount() {
    const {
      remoteSubmit,
      citySlugified,
      storeSlugified,
      match: {
        params: { slug },
      },
    } = this.props;

    this.props.trackSaveUrlFragments({
      service: slug || '',
      city: citySlugified || '',
      store: storeSlugified || '',
    });

    this.selectTimeOfDayFilter(moment('07:00', 'HH:mm'));
    remoteSubmit();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedCity !== prevProps.selectedCity) {
      const { timeSlotsFiltered, stateTimeSlots, fetchTimeStamp, updateTimeStamp } = this.state;

      if (
        JSON.stringify(timeSlotsFiltered) !== JSON.stringify(stateTimeSlots) ||
        (fetchTimeStamp && fetchTimeStamp > updateTimeStamp)
      ) {
        trackAvailableTimes(timeSlotsFiltered);
        this.setState({ updateTimeStamp: fetchTimeStamp, stateTimeSlots: timeSlotsFiltered });
        // eslint-disable-next-line react/destructuring-assignment
        this.props.clearFetchTimeStamp();
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(timeout);
  }

  selectTimeOfDayFilter = time => {
    this.setState({
      timeFilter: time,
    });
  };

  // eslint-disable-next-line class-methods-use-this
  getOpticianNameById = (id, availableOpticians) => {
    if (!id || availableOpticians.length === 0) return '';

    const correctOptician = availableOpticians.filter(optician => optician.key === id.toString());

    return correctOptician.length > 0 ? R.path(['value'], correctOptician[0]) : '';
  };

  // eslint-disable-next-line class-methods-use-this
  getKeyForTimeSlot = item => `${item.key}${item.storeId}${item.appointmentType}`;

  render() {
    const {
      trackTimeFilterMorning,
      trackTimeFilterDay,
      trackTimeFilterAfternoon,
      trackTimeFilterEvening,
      classes,
      handleSubmit,
      clearAvailability,
      clearAvailableOpticians,
      clearMonthAvailability,
      getAvailability,
      getSpecialists,
      availableTimes,
      redirection,
      availabilityCallInProgress,
      specialistCallInProgress,
      fetchedMonthAvailabilities,
      stores,
      history,
      cities,
      selectedCity,
      selectedStore,
      selectedOptician,
      selectedServiceBox,
      storesGroupedByCities,
      opticiansAvailable,
      storesWhereAvailable,
      setAvailabilityStartDate,
      i18n,
      t,
      lang,
      localeLong,
      showOnlyStartTime,
      subServiceUrlFragment,
    } = this.props;
    const { timeFilter, reservationDate } = this.state;

    let timeSlots = [];

    moment.locale(lang);

    if (lang === 'fi') {
      moment.updateLocale('fi', {
        weekdays: [
          'sunnuntaina',
          'maanantaina',
          'tiistaina',
          'keskiviikkona',
          'torstaina',
          'perjantaina',
          'lauantaina',
        ],
      });
    }

    const getLocale = () => i18n.language;

    let availableTimesFiltered = availableTimes;

    let filteredCities = cities;

    const defaultLanguageGatCode = getDefaultGatCode();
    const languageGatCode = getLanguageGatCode(lang);

    if (storesWhereAvailable && storesWhereAvailable.length > 0) {
      const citiesFilteredByStore = Object.values(storesGroupedByCities).filter(
        city =>
          city.filter(store =>
            storesWhereAvailable.includes(R.path(['attributes', 'name', defaultLanguageGatCode], store)),
          ).length > 0,
      );

      filteredCities = R.uniq(citiesFilteredByStore.map(city => R.path(['city'], city[0])));
    }
    // Clear time slots, and populate them only if there are available times
    timeSlots = [];
    if (availableTimes) {
      const match = availableTimes.filter(
        item => item.attributes.date === moment(reservationDate).format('YYYY-MM-DD'),
      );
      if (match.length > 0) {
        // Available times were found on selected day
        const timeSlotsPerStore = match.map(item => item.attributes.timeSlots);

        // Concatenate together
        let allStoresTimeSlots = [];
        allStoresTimeSlots = allStoresTimeSlots.concat(...timeSlotsPerStore);
        allStoresTimeSlots.forEach(item => {
          // check for duplicates, sometimes when user clicks fast on the day change, there might be duplicate entries
          const existingItem = timeSlots.find(slot => this.getKeyForTimeSlot(item) === this.getKeyForTimeSlot(slot));
          if (!existingItem) {
            timeSlots.push(item);
          }
        });
      }
    }

    const minutesOfDay = function (m) {
      return m.minutes() + m.hours() * 60;
    };

    // Display timeslots based on user defined startTime & store filters
    let timeSlotsFiltered = timeSlots.filter(item => {
      const startTimeParsed = moment(item.startTime, 'YYYY-MM-DDTHH:mm:ss');

      const isAfter = minutesOfDay(startTimeParsed) >= minutesOfDay(timeFilter);

      if (selectedStore) {
        const matchStore = JSON.parse(selectedStore).key === item.storeId;
        return isAfter && matchStore && item;
      }
      return isAfter && item;
    });

    // Filter calendar display if store is selected
    if (selectedStore) {
      availableTimesFiltered = availableTimesFiltered.filter(item => item.storeId === JSON.parse(selectedStore).key);
    }

    // Sort timeslots based on their startTime
    const sortByFirstItem = R.sortBy(R.prop('startTime'));
    timeSlotsFiltered = sortByFirstItem(timeSlotsFiltered);
    const groupedByStore = groupBy(timeSlotsFiltered, availableTime => availableTime.storeId);
    // sort grouped timeslots alphabetically
    const sortedTimeSlots = Object.entries(groupedByStore)
      .map(([key, value]) => {
        const storeDetails = R.find(R.propEq('id', key))(stores);
        const timeSlots = sortByFirstItem(value);
        return {
          id: key,
          name: R.path(['attributes', 'name', languageGatCode], storeDetails),
          city: R.path(['attributes', 'address', 'city'], storeDetails),
          storeDetails,
          timeSlots,
        };
      })
      .sort(sortStoresAlphabetically('name'));
    // split timeslots for selected city and nearby stores, and add slots for selected city before nearby slots
    const timeSlotsForSelectedCity = sortedTimeSlots.filter(s => s.city === selectedCity);
    const timeSlotsForNearbyStores = sortedTimeSlots.filter(s => s.city !== selectedCity);
    const storeWithTimeSlots = [...timeSlotsForSelectedCity, ...timeSlotsForNearbyStores];

    let storesWithinSelectedCity = [];

    if (selectedCity && Array.isArray(storesGroupedByCities[selectedCity])) {
      if (storesWhereAvailable && storesWhereAvailable.length > 0) {
        storesGroupedByCities[selectedCity].forEach(item => {
          if (storesWhereAvailable.includes(R.path(['attributes', 'name', defaultLanguageGatCode], item))) {
            storesWithinSelectedCity.push({
              key: R.path(['id'], item),
              value: R.path(['attributes', 'name', languageGatCode], item),
            });
          }
        });
      } else {
        storesWithinSelectedCity = storesGroupedByCities[selectedCity].map(item => ({
          key: R.path(['id'], item),
          value: R.path(['attributes', 'name', languageGatCode], item),
        }));
      }

      // Rearrange stores alphabetically
      storesWithinSelectedCity.sort((a, b) => a.value.localeCompare(b.value));
    }

    // Get opticians per store and map for selected field
    let opticiansMappedForSelectField = [];

    opticiansMappedForSelectField = opticiansAvailable.filter(
      (item, index, self) => index === self.findIndex(optician => optician.key === item.key),
    ); // Avoid duplicates

    if (selectedStore) {
      opticiansMappedForSelectField = opticiansAvailable.filter(item => item.storeId === JSON.parse(selectedStore).key);
    }

    opticiansMappedForSelectField.sort((a, b) => a.value.localeCompare(b.value));

    const pageTitle = [R.path(['headline'], selectedServiceBox)];

    if (selectedStore) {
      pageTitle.push(JSON.parse(selectedStore).value);
    }

    const requestAbortController = React.useRef < AbortController;

    const handleDaySelection = newDate => {
      this.setState({ reservationDate: newDate });
    };

    const handleMonthChange = month => {
      if (requestAbortController.current) {
        // make sure that you are aborting useless requests
        // because it is possible to switch between months pretty quickly
        requestAbortController.current.abort();
        return;
      }

      if (fetchedMonthAvailabilities.includes(month.format('MM-YYYY'))) {
        // Do no fetch availabilities again if they have been fetched already but save current viewed month.
        setAvailabilityStartDate(month.format('YYYY-MM-DD'));
        return;
      }

      const values = {
        city: selectedCity,
        person: selectedOptician,
        store: selectedStore,
        availabilityStartDate: month.format('YYYY-MM-DD'),
      };

      getAvailability(values);
    };

    let redirectionText = get(redirection, [`infoTextIn${localeLong}`]);

    if (redirectionText) {
      localStorage.setItem('alertText', redirectionText);
    } else {
      redirectionText = localStorage.getItem('alertText');
      setTimeout(() => {
        localStorage.removeItem('alertText');
      }, '3000');
    }

    const onCityChange = (event, newValue) => {
      clearAvailableOpticians();
      clearAvailability();
      getAvailability({ city: newValue });
    };
    const onStoreChange = (event, newValue) => {
      clearAvailability();
      getAvailability({ city: selectedCity, store: newValue });
    };
    const onPersonChange = (event, newValue) => {
      clearMonthAvailability();
      clearAvailability();
      getAvailability({ city: selectedCity, person: newValue, store: selectedStore });
    };
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{getPageTitle(pageTitle)}</title>
        </Helmet>
        <Grid container direction="row" spacing={0}>
          <Grid item xs={12} className={classes.breadcrumb}>
            <Breadcrumb lang={getLocale()} currenttabindex={2} subServiceUrlFragment={subServiceUrlFragment} />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={0}>
          <Grid item xs={12} className={`${classes.chooseLocationAndTime} ${classes.paddingLeftRight}`}>
            <Title icon="calendar">{t('views.selectService.chooseLocationAndTime')}</Title>
          </Grid>
          {redirectionText && (
            <Grid item xs={12} className={classes.alert}>
              <Alert text={redirectionText} type="error" />
            </Grid>
          )}
          <Grid item xs={12} md={8} className={classes.form}>
            <form className={classes.form} onSubmit={handleSubmit(getAvailability)}>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <Field
                    key="city"
                    id="city"
                    name="city"
                    component={returnField('select')}
                    label={t('views.selectService.city')}
                    type="text"
                    selOpts={filteredCities}
                    fullWidth
                    required
                    onChange={onCityChange}
                  />
                </Grid>
                {selectedCity && (
                  <Grid item xs={12} md={6} className={classes.field}>
                    <Field
                      key="store"
                      id="store"
                      name="store"
                      component={returnField('select')}
                      label={t('views.selectService.store')}
                      placeholder={
                        selectedCity
                          ? `${capitalizeFirstLetter(selectedCity)} + ${t('views.selectService.selectStore')}`
                          : t('views.selectService.selectStore')
                      }
                      type="text"
                      disabled={!selectedCity}
                      selOpts={storesWithinSelectedCity}
                      optionsAreObjects
                      fullWidth
                      onChange={onStoreChange}
                    />
                  </Grid>
                )}

                {selectedCity && get(settings, 'showOpticians', true) && (
                  <Grid item xs={12} md={12}>
                    <Field
                      disabled={!selectedCity || availabilityCallInProgress}
                      key="person"
                      id="person"
                      name="person"
                      component={returnField('select')}
                      label={t('views.selectService.specialist')}
                      type="text"
                      selOpts={opticiansMappedForSelectField}
                      fullWidth
                      placeholder={
                        availabilityCallInProgress
                          ? `${t('views.selectService.loadingOpticians')}...`
                          : t('views.selectService.selectOptician')
                      }
                      optionsAreObjects
                      dataFetchInProgress={specialistCallInProgress}
                      onOpen={() => {
                        if (selectedCity !== undefined && opticiansMappedForSelectField.length === 0) {
                          const values = {
                            city: selectedCity,
                            store: selectedStore,
                          };

                          getSpecialists(values);
                        }
                      }}
                      onChange={onPersonChange}
                    />
                  </Grid>
                )}

                {selectedCity && (
                  <Grid item xs={12} sm="auto" md={6} style={{ position: 'relative', display: 'table' }}>
                    <Calendar
                      key="reservationDate"
                      id="reservationDate"
                      name="reservationDate"
                      component={returnField('date')}
                      label={t('views.selectService.day')}
                      type="date"
                      lang={lang}
                      disabled={availabilityCallInProgress}
                      availableTimes={
                        availableTimesFiltered && Array.isArray(availableTimesFiltered) && availableTimesFiltered
                      }
                      onMonthChange={handleMonthChange}
                      onChange={handleDaySelection}
                      value={reservationDate}
                      loading={availabilityCallInProgress}
                    />
                  </Grid>
                )}
              </Grid>
            </form>
          </Grid>

          <Grid item xs={12} md={4} className={classes.serviceBox}>
            <SelectedServiceBox content={selectedServiceBox} />
          </Grid>

          <Grid item xs={12} md={8} className={classes.availableTimes}>
            <Typography variant="h3" gutterBottom className={classes.h3}>
              {t('views.selectService.freeSlots')} {moment(reservationDate).locale(lang).format('dddd D.M.YYYY')}
            </Typography>
            <ButtonGroup
              color="secondary"
              aria-label="outlined secondary button group"
              fullWidth
              className={classes.buttonGroup}>
              <Button
                disableRipple
                variant={moment('07:00', 'HH:mm').isSameOrAfter(timeFilter) ? 'contained' : 'outlined'}
                onClick={() => {
                  trackTimeFilterMorning();
                  this.selectTimeOfDayFilter(moment('07:00', 'HH:mm'));
                }}
                className={classes.buttonGroupButton}>
                <div className={classes.timeSelectionWrapper}>
                  {moment('07:00', 'HH:mm').isSameOrAfter(timeFilter) && <CheckCircle />}
                  <span className={classes.timeSelectionSpan}>{t('views.selectService.morning')}</span>
                  <span>
                    7:00 <ArrowForward className={classes.arrowForwardStyle} />
                  </span>
                </div>
              </Button>
              <Button
                disableRipple
                variant={moment('11:00', 'HH:mm').isSameOrAfter(timeFilter) ? 'contained' : 'outlined'}
                onClick={() => {
                  trackTimeFilterDay();
                  this.selectTimeOfDayFilter(moment('11:00', 'HH:mm'));
                }}
                className={classes.buttonGroupButton}>
                <div className={classes.timeSelectionWrapper}>
                  {moment('11:00', 'HH:mm').isSameOrAfter(timeFilter) && <CheckCircle />}
                  <span className={classes.timeSelectionSpan}>{t('views.selectService.day')}</span>
                  <span>
                    11:00 <ArrowForward className={classes.arrowForwardStyle} />
                  </span>
                </div>
              </Button>
              <Button
                disableRipple
                variant={moment('15:00', 'HH:mm').isSameOrAfter(timeFilter) ? 'contained' : 'outlined'}
                onClick={() => {
                  trackTimeFilterAfternoon();
                  this.selectTimeOfDayFilter(moment('15:00', 'HH:mm'));
                }}
                className={classes.buttonGroupButton}>
                <div className={classes.timeSelectionWrapper}>
                  {moment('15:00', 'HH:mm').isSameOrAfter(timeFilter) && <CheckCircle />}
                  <span className={classes.timeSelectionSpan}>{t('views.selectService.afternoon')}</span>
                  <span>
                    15:00 <ArrowForward className={classes.arrowForwardStyle} />
                  </span>
                </div>
              </Button>
              <Button
                disableRipple
                variant={moment('18:00', 'HH:mm').isSameOrAfter(timeFilter) ? 'contained' : 'outlined'}
                onClick={() => {
                  trackTimeFilterEvening();
                  this.selectTimeOfDayFilter(moment('18:00', 'HH:mm'));
                }}
                className={classes.buttonGroupButton}>
                <div className={classes.timeSelectionWrapper}>
                  {moment('18:00', 'HH:mm').isSameOrAfter(timeFilter) && <CheckCircle />}
                  <span className={classes.timeSelectionSpan}>{t('views.selectService.evening')}</span>
                  <span>
                    18:00 <ArrowForward className={classes.arrowForwardStyle} />
                  </span>
                </div>
              </Button>
            </ButtonGroup>

            <Box mb={2}>
              <Info>
                <Typography variant="body1">
                  {!selectedCity && t('views.selectService.selectCity')}
                  {selectedCity &&
                    moment('07:00', 'HH:mm').isSame(timeFilter) &&
                    t('views.selectService.allTimesShown')}
                  {selectedCity && moment('07:00', 'HH:mm').isBefore(timeFilter) && (
                    <span>
                      {t('views.selectService.showingTimesBetween')} {timeFilter.format('HH:mm')}–20:00.
                    </span>
                  )}
                </Typography>
              </Info>
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
            {!availabilityCallInProgress &&
              timeSlotsFiltered &&
              timeSlotsFiltered.length > 0 &&
              storeWithTimeSlots.map(({ storeDetails, id, name, timeSlots }) => (
                <div key={id}>
                  <Accordion TransitionProps={{ unmountOnExit: true }}>
                    <AccordionSummary
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      className={classes.storeDetailsWrapper}>
                      <Grid container justifyContent="space-between" alignItems="center">
                        <Grid item>
                          <Typography variant="h3" className={classes.organisationName}>
                            {name}
                          </Typography>
                          <Typography variant="body1" className={classes.organisationAddress}>
                            {`${R.path(['attributes', 'address', 'line1'], storeDetails)}, ${R.path(
                              ['attributes', 'address', 'city'],
                              storeDetails,
                            )}`}
                          </Typography>
                          {(selectedStore === '' || selectedStore === undefined) && (
                            <Box>
                              <Info className={classes.helpBox}>
                                <Typography variant="body2">{t('views.selectService.inTheLocalArea')}</Typography>
                              </Info>
                            </Box>
                          )}
                        </Grid>
                        <Grid item>
                          <Button
                            color="primary"
                            className={clsx(classes.button, classes.toggleMapButton)}
                            startIcon={<CustomIcon icon="location" />}
                            endIcon={<KeyboardArrowDown />}>
                            <span className="hideMapText">{t('views.selectService.hideMap')}</span>
                            <span className="showMapText">{t('views.selectService.showMap')}</span>
                          </Button>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails className={classes.mapAccordionDetails}>
                      <GoogleMap
                        query={`${process.env.REACT_APP_BRAND} ${get(storeDetails, [
                          'attributes',
                          'address',
                          'line1',
                        ])} ${get(storeDetails, ['attributes', 'address', 'city'])}`}
                      />
                    </AccordionDetails>
                  </Accordion>
                  <div className={classes.availableTimesWrapper}>
                    {timeSlots &&
                      timeSlots.length > 0 &&
                      timeSlots.map((item, index) => (
                        <AvailableTime
                          // eslint-disable-next-line react/no-array-index-key
                          key={`${index}${item.key}${item.storeId}${item.appointmentType}`}
                          day={moment(reservationDate).format('dddd D.M.YYYY')}
                          storeId={item.storeId}
                          appointmentType={item.appointmentType}
                          stores={stores}
                          history={history}
                          content={item}
                          lang={lang}
                          showOnlyStartTime={showOnlyStartTime}
                          selectedOptician={selectedOptician ? JSON.parse(selectedOptician).key : item.opticians[0]}
                          selectedOpticianName={
                            selectedOptician
                              ? JSON.parse(selectedOptician).value
                              : this.getOpticianNameById(item.opticians[0], opticiansMappedForSelectField)
                          }
                        />
                      ))}
                  </div>
                </div>
              ))}
            {selectedCity && !availabilityCallInProgress && (!timeSlotsFiltered || timeSlotsFiltered.length < 1) && (
              <Typography variant="body1" gutterBottom className={classes.progressContainer}>
                {t('views.selectService.noFreeSlots')}
              </Typography>
            )}

            {availabilityCallInProgress && (
              <div className={classes.progressContainer}>
                <CircularProgress className={classes.circularProgress} />
                <Typography variant="body1" display="inline" gutterBottom className={classes.loading}>
                  {t('views.selectService.loading')}
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector('selectService');

  const initialValues = {};

  const subServiceUrlFragment = R.path(['availability', 'subServiceUrlFragment'], state);
  // Initialize form with url params
  const cityParam = R.path(['match', 'params', 'city'], ownProps);
  const storeParam = R.path(['match', 'params', 'store'], ownProps);
  if (cityParam) {
    const selectedCity = R.path(['availability', 'storesGroupedByCitiesByUrlKey', cityParam], state);
    const firstStore = R.head(selectedCity);
    const cityName = R.path(['city'], firstStore);
    initialValues.city = cityName;
  }
  if (cityParam && storeParam) {
    const selectedCity = R.path(['availability', 'storesGroupedByCitiesByUrlKey', cityParam], state);
    const selectedStore = R.head(selectedCity.filter(item => item.url === storeParam));
    const storeKey = R.path(['id'], selectedStore);
    const storeName = R.path(['attributes', 'name', R.path(['contentful', 'locale'], state)], selectedStore);
    initialValues.store = JSON.stringify({ key: storeKey, value: storeName });
  }

  return {
    availableTimes: R.path(['availability', 'available_time_slots'], state),
    redirection: R.path(['contentful', 'redirection'], state),
    redirections: R.path(['contentful', 'redirections'], state),
    storesWhereAvailable: R.path(['availability', 'storesWhereAvailable'], state),
    availabilityCallInProgress: R.path(['availability', 'availabilityCallInProgress'], state),
    specialistCallInProgress: R.path(['availability', 'specialistCallInProgress'], state),
    fetchTimeStamp: R.path(['availability', 'fetchTimeStamp'], state),
    reservationDate: R.path(['form', 'selectService', 'values', 'reservationDate'], state),
    cities: R.path(['availability', 'cities'], state),
    stores: R.path(['availability', 'stores'], state),
    storesGroupedByCities: R.path(['availability', 'storesGroupedByCities'], state),
    opticiansAvailable: R.path(['availability', 'opticiansAvailable'], state),
    selectedCity: selector(state, 'city'),
    selectedStore: selector(state, 'store'),
    selectedOptician: selector(state, 'person'),
    selectedServiceBox: {
      headline: R.path(['availability', 'subService'], state),
      description: R.path(['availability', 'subServiceDescription'], state),
      price: R.path(['availability', 'price'], state),
    },
    initialValues,
    fetchedMonthAvailabilities: R.path(['availability', 'fetchedMonthAvailabilities'], state),
    localeLong: R.path(['contentful', 'localeLong'], state),
    showOnlyStartTime:
      (isEqual(subServiceUrlFragment, 'optician-eye-examination') ||
        isEqual(subServiceUrlFragment, 'optician-eye-test')) &&
      !isEqual(siteId, siteIds.InstrumentariumEE),
    subServiceUrlFragment,
  };
};

const mapDispatchToProps = dispatch => ({
  getAvailability: values => dispatch(getAvailability(values)),
  getSpecialists: values => dispatch(getSpecialists(values)),
  clearAvailability: () => dispatch(clearAvailability()),
  clearUsedRedirection: () => dispatch(clearUsedRedirection()),
  saveUsedRedirection: redirect => dispatch(saveUsedRedirection(redirect)),
  clearMonthAvailability: () => dispatch(clearMonthAvailability()),
  clearAvailableOpticians: () => dispatch(clearAvailableOpticians()),
  setAvailabilityStartDate: values => dispatch(setAvailabilityStartDate(values)),
  remoteSubmit: () => dispatch(submit('selectService')),
  trackTimeFilterMorning: () => dispatch(trackTimeFilterMorning()),
  trackTimeFilterDay: () => dispatch(trackTimeFilterDay()),
  trackTimeFilterAfternoon: () => dispatch(trackTimeFilterAfternoon()),
  trackTimeFilterEvening: () => dispatch(trackTimeFilterEvening()),
  trackSaveUrlFragments: values => dispatch(trackSaveUrlFragments(values)),
  trackUrlChange: () => dispatch(trackUrlChange()),
  trackAvailableTimes: values => dispatch(trackAvailableTimes(values)),
  clearFetchTimeStamp: () => dispatch(clearFetchTimeStamp()),
});

const FormDecoratedComponent = reduxForm({
  form: 'selectService',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
  updateUnregisteredFields: true,
  onChange: (values, dispatch, props, previousValues) => {
    props.clearUsedRedirection();

    // User has changed city or store -> update url
    if (
      R.path(['city'], previousValues) !== R.path(['city'], values) ||
      R.path(['store'], previousValues) !== R.path(['store'], values)
    ) {
      const urlReplaceNordicChars = string => {
        return string
          .replace(/ä/g, 'a')
          .replace(/Ä/g, 'A')
          .replace(/ö/g, 'o')
          .replace(/Ö/g, 'O')
          .replace(/å/g, 'a')
          .replace(/Å/g, 'A')
          .replace(/ /g, '-')
          .replace(/,/g, '-');
      };

      let cityandstore = '';
      const storeParsed = R.path(['store'], values) ? JSON.parse(R.path(['store'], values)).value : null;
      const citySlugified = R.path(['city'], values) && urlReplaceNordicChars(R.path(['city'], values)).toLowerCase();
      let storeSlugified = storeParsed && urlReplaceNordicChars(storeParsed).toLowerCase();
      let redirect = false;
      const defaultLocaleLong = getDefaultLocaleLong();

      if (storeParsed) {
        const { redirections } = props;

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < redirections.length; i++) {
          if (
            get(
              redirections,
              [i, `fromIn${props.localeLong}`],
              get(redirections, [i, `fromIn${defaultLocaleLong}`]),
            ) === storeSlugified
          ) {
            storeSlugified = get(
              redirections,
              [i, `toIn${props.localeLong}`],
              get(redirections, [i, `toIn${defaultLocaleLong}`]),
            );
            props.saveUsedRedirection(redirections[i]);
            redirect = true;
            break;
          }
        }
      }

      if (R.path(['city'], values)) {
        cityandstore = storeParsed ? `/${citySlugified}/${storeSlugified}` : `/${citySlugified}`;
      } else {
        cityandstore = '';
      }

      // Alter url based on user selections
      // eslint-disable-next-line no-unused-expressions
      window && window.history.replaceState(null, '', `/${props.lang}/${props.match.params.slug}${cityandstore}`);
      props.trackUrlChange();
      props.clearMonthAvailability();

      if (redirect) {
        window.location.reload();
      }
    }

    // reset store and person on city change
    if (R.path(['city'], previousValues) !== R.path(['city'], values)) {
      dispatch(change('selectService', 'store', ''));
      dispatch(change('selectService', 'person', ''));
      dispatch(untouch('selectService', 'store'));
      dispatch(untouch('selectService', 'person'));
      // Clear selected person on store change if it has been selected.
    } else if (R.path(['person'], values) && R.path(['store'], previousValues) !== R.path(['store'], values)) {
      dispatch(change('selectService', 'person', ''));
      dispatch(untouch('selectService', 'person'));
    }
  },
  onSubmit: (values, dispatch, props) => {
    const today = moment();
    props.clearAvailability();
    props.clearMonthAvailability();
    props.setAvailabilityStartDate(today);
    props.clearAvailableOpticians();
    values.person = '';
    props.getAvailability(values);
  },
})(SelectService);

export default withStyles(inlineStyles)(
  withTranslation('translations')(connect(mapStateToProps, mapDispatchToProps)(FormDecoratedComponent)),
);
